import {IDischargeModel} from '../../api/api.types';

export interface IStationCreatorHQTable {
  dischargeModel:IDischargeModel;
  minWaterLevel:number,
  maxWaterLevel:number
}

export class StationCreatorHQTableController implements IStationCreatorHQTable {
  static $inject = ['$mdDialog'];

  dischargeModel:IDischargeModel;
  minWaterLevel:number;
  maxWaterLevel:number;

  constructor(private $mdDialog:ng.material.IDialogService) {
  }

  cancelDialog() {
    this.$mdDialog.cancel();
  }
}



/** WEBPACK FOOTER **
 ** ./app/station/creator/curve-hq-table.controller.ts
 **/